import type { GQLLocale } from 'graphql-ts-types';

import { useFetchValidations } from '../../components/DynamicForm/hooks/fetch-validations';
import type { GqlValidationRules } from '../../components/DynamicForm/types';
import { executeQuery } from '../../gql';
import type {
  BirthdateValidationRulesQuery,
  BirthdateValidationRulesQueryVariables,
} from '../../gql/generated/schema';
import { combineQueryWithFragments } from '../../gql/utils/fragments';
import { captureMessage } from '../../utils/error-reporter';
import baseValidationRuleAttributes from './gql/fragment/baseValidationRuleAttributes.gql';
import validationRuleAttributes from './gql/fragment/validationRuleAttributes.gql';
import validationRuleGroupAttributes from './gql/fragment/validationRuleGroupAttributes.gql';
import birthdateValidationRulesQuery from './gql/query/birthdateValidationRules.gql';

const fetchBirthdateRules = async (locale: GQLLocale) => {
  try {
    const { validationRules } = await executeQuery<
      BirthdateValidationRulesQuery,
      BirthdateValidationRulesQueryVariables
    >({
      query: combineQueryWithFragments(
        birthdateValidationRulesQuery,
        baseValidationRuleAttributes,
        validationRuleAttributes,
        validationRuleGroupAttributes
      ),
      variables: { locale },
    });

    return validationRules.birthdate as GqlValidationRules;
  } catch (error) {
    captureMessage(`Failed to fetch the birthdate validation rules. ${error}`);
  }
};

export const useBirthdateGqlValidations = () => useFetchValidations(fetchBirthdateRules);
